import { render, staticRenderFns } from "./AdministrativeSettings.vue?vue&type=template&id=21fee4c3"
import script from "./AdministrativeSettings.vue?vue&type=script&lang=js"
export * from "./AdministrativeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports